export class Type {
     code: string = "";

     libelle: string = "";
}